import { render, staticRenderFns } from "./chats.vue?vue&type=template&id=0e81b557&scoped=true"
import script from "./chats.vue?vue&type=script&lang=js"
export * from "./chats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e81b557",
  null
  
)

export default component.exports